import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import Swal from 'sweetalert2';
import { getSwal } from '../../../../../utils/swalObject';
import { TipoRespostaService } from '../../../../../service/configuracao/tipo-resposta.service';

@Component({
  selector: 'app-editar-tipo-resposta',
  templateUrl: './editar-tipo-resposta.component.html',
  styleUrls: ['./editar-tipo-resposta.component.scss']
})
export class EditarTipoRespostaComponent implements OnInit {
   routeSub: Subscription;
      editarTipoRespostaForm: FormGroup;
      idTipoResposta:number = null;
      edicao:boolean = false;

      constructor(
          private fb: FormBuilder,
          private route: ActivatedRoute,
          private router: Router,
          private tipoRespostaService: TipoRespostaService) { }

      ngOnInit() {
          this.criarFormulario();
          this.routeSub = this.route.params.subscribe(params => {
              if (params['id']) {
                  this.idTipoResposta = params['id'];
              }
          });
          if(this.idTipoResposta) {
            this.carregarDados();
          }
      }

      criarFormulario(){
          this.editarTipoRespostaForm = this.fb.group({
            descricao: ['', Validators.required],
            ativo: [false, Validators.required]
          })
      }

      carregarDados(){
      this.tipoRespostaService.obterTipoResposta(this.idTipoResposta).subscribe(res => {
          const data = res.resultado;
          for (let key in data) {
          if(this.editarTipoRespostaForm.controls[key]) {
              this.editarTipoRespostaForm.controls[key].patchValue(data[key]);
          }
          }
      }, error => {
          Swal.fire(
          getSwal(
              'error',
              'Ops!',
              "Ocorreu um erro e a forma de acesso não pôde ser carregada.",
              'ok',
              null,
          ),
          );
      });
      }

      isFormInvalid(){
      if(this.editarTipoRespostaForm.valid) {
          return false;
      } else {
          return true;
      }
      }

      onSubmit() {
      const value = this.editarTipoRespostaForm.getRawValue();
          this.tipoRespostaService.editaTipoResposta(value, this.idTipoResposta).subscribe(res => this.handleResponse(), error => this.handleError(error));
      }

      handleResponse(){
      Swal.fire(
          getSwal(
          'success',
          'Sucesso!',
          "O tipo de resposta foi editado com sucesso.",
          'ok',
          null,
          ),
      );
      this.router.navigate(['configuracao/tipo-resposta/consultar']);
      }

      handleError(error){
      Swal.fire(
          getSwal(
          'error',
          'Ops!',
          "Ocorreu um erro e o tipo de resposta não pôde ser editado.",
          'ok',
          null,
          ),
      );

      }

  }
